/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button, Flex, Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import {
  ActionEnum,
  DlpPolicyItem,
  KfCollaborationActionTypeEnum,
  KfContainRule,
  KfContainTypeEnum,
  KfDefaultLogicalOperatorEnum,
  KfFileTypeEnum,
} from '@Policy/utils/types';
import isEqual from 'lodash/isEqual';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import {
  useKfContainRuleListColumns,
  useKfContainRuleListRows,
} from '../../hooks/keywordExtractionFilter';
import { ExceptionListTable } from '../../Components';
import { useKfContainRuleListStyle } from '../../Components/styles';
import RuleModal from './RuleModal';
import { getEmptyRule } from '@Policy/TemplateConfig/cfg.box.dlp';

const emptyRule: KfContainRule = getEmptyRule();
const RuleList = () => {
  const { t } = useTranslation();

  const { tableStyleProps } = useKfContainRuleListStyle();
  const [isVisible, setIsVisible] = React.useState(false);
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get state from store
  const kfContainRules = policySelector(
    (s) => s.tmKeywordfilters?.kfContainRules,
    isEqual
  );
  const addKfContainRule = contextSelector((s) => s.addKfContainRule);
  const deleteKfContainRule = contextSelector((s) => s.deleteKfContainRule);
  const setKfContainRuleAction = contextSelector(
    (s) => s.setKfContainRuleAction
  );

  const handleDeleteClick = React.useCallback((index: number) => {
    deleteKfContainRule(index);
  }, []);
  const handleActionChange = React.useCallback(
    (index: number, action: ActionEnum) => {
      setKfContainRuleAction(index, action);
    },
    []
  );
  const handleModalClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAddClick = React.useCallback(() => {
    setIsVisible(true);
  }, []);
  const handleModalSave = React.useCallback((rule: KfContainRule[]) => {
    console.log('save', rule);
    // set tempVars to slfExcetpionList
    addKfContainRule(rule);
  }, []);

  const { kfContainRuleListColumns } = useKfContainRuleListColumns(
    handleDeleteClick,
    handleActionChange
  );
  const { kfContainRuleListRows } = useKfContainRuleListRows(
    kfContainRuleListColumns
  );

  return (
    <>
      <Flex direction="column">
        <Button mt="10px" mb="10px" width="50px" onClick={handleAddClick}>
          Add
        </Button>
        <Flex height="1000px" width="800px">
          <ExceptionListTable
            tableStyle={tableStyleProps}
            columns={kfContainRuleListColumns}
            rows={kfContainRuleListRows}
          />
        </Flex>
      </Flex>
      <RuleModal
        isVisible={isVisible}
        onClose={handleModalClose}
        saveConfig={handleModalSave}
        data={emptyRule}
      />
    </>
  );
};

export default RuleList;
